import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { IDeleteDataResponseAndPayload, TResponse, TResponseWithQData } from "../../../types/common";
import { IQuote, IQuoteCreatePayload, IQuoteSendPayload, IQuoteUpdatePayload } from "../../../types/api/quote";

export async function listQuote(
  qData: QData
): Promise<AxiosResponse<TResponseWithQData<IQuote[]>>> {
  return axios.get(API_ENDPOINTS.QUOTE_LIST, { params: qData });
}

export async function quoteDetail(
  id: string | number
): Promise<AxiosResponse<TResponse<IQuote>>> {
  return axios.get(`${API_ENDPOINTS.QUOTE_DETAIL}/${id}`);
}

export async function createQuote(
  data: IQuoteCreatePayload
): Promise<AxiosResponse<TResponse<IQuote>>> {
  return axios.post<TResponse<IQuote>>(API_ENDPOINTS.QUOTE_CREATE, data);
}

export async function updateQuote(
  data: IQuoteUpdatePayload
): Promise<AxiosResponse<TResponse<IQuote>>> {
  return axios.post<TResponse<IQuote>>(API_ENDPOINTS.QUOTE_UPDATE, data);
}

export async function deleteQuote(
  data: IDeleteDataResponseAndPayload
): Promise<AxiosResponse<TResponse<IDeleteDataResponseAndPayload>>> {
  return axios.post<TResponse<IDeleteDataResponseAndPayload>>(API_ENDPOINTS.QUOTE_DELETE, data);
}

export async function sendQuote(
  data: IQuoteSendPayload
): Promise<AxiosResponse<TResponse<{ token: string; public_url: string; pdf_url?: string }>>> {
  return axios.post(API_ENDPOINTS.QUOTE_SEND, data);
}

export async function convertQuoteToJob(
  data: { id: number }
): Promise<AxiosResponse<TResponse<any>>> {
  return axios.post(API_ENDPOINTS.QUOTE_CONVERT_TO_JOB, data);
}

export async function acceptQuoteOnBehalf(
  data: { id: number }
): Promise<AxiosResponse<TResponse<any>>> {
  const url = API_ENDPOINTS.QUOTE_ACCEPT_ON_BEHALF.replace(":id", String(data.id));
  return axios.post(url, {});
}
